import { Picker } from 'emoji-mart';
import 'emoji-mart/css/emoji-mart.css';
import { TFunction } from 'next-i18next';

import React, { useRef, useState } from 'react';

import { Icon } from '@thinkific/chalk/react-icons';
import { Popover } from '@thinkific/chalk/recipes/Popover';

import getDictionary from 'components/EmojiPicker/EmojiPickerDictionary';

import { Editor } from '../../../hooks/useEditor/useEditor';
import ActionButton from '../../ActionButton';
import * as css from './EmojiPicker.css';

interface EmojiPickerProps {
  icon: Icon;
  t: TFunction;
  editor: Editor | null;
  disabled?: boolean;
  onClick: () => void;
}

const EmojiPicker = ({ icon, editor, t, disabled, onClick }: EmojiPickerProps) => {
  const emojiRef = useRef<HTMLButtonElement>(null);
  const [isOpen, setIsOpen] = useState(false);
  const handleSelect = (emoji) => {
    const { native } = emoji;
    if (native) {
      editor?.chain().focus().insertContent(native).run();
    }
    emojiRef.current?.click();
    setIsOpen(false);
  };

  const handleOpen = () => {
    setIsOpen(true);
    onClick?.();
  };

  return (
    <div className={css.emojiPicker} data-qa="emoji-picker">
      <Popover
        title={t('community.documentEditor.menuBar.emojiPicker', 'Add emoji')}
        trigger={
          <ActionButton
            arialLabel={t('Emoji')}
            disabled={disabled || false}
            icon={icon}
            isActive={isOpen}
            ref={emojiRef}
            onClick={handleOpen}
          />
        }
        triggerRef={emojiRef}
        hiddenTitle
      >
        <Picker
          i18n={getDictionary(t)}
          showPreview={false}
          showSkinTones={false}
          emojiTooltip
          native
          onSelect={handleSelect}
        />
      </Popover>
    </div>
  );
};

export default EmojiPicker;
